import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {getStringFeatureName} from "../../misc/helpers";
import {truncate} from "../sqft/helpers/sqftHelper";
import {highlightStringOnSearch} from "../../misc/misc2";

const FeatureName = (props) => {
  const {feature, intl, fabricatorData, maxLength, filterGroups, useCollectionName, groheFiltersSearchText} = props;
  let stringFeatureName = getStringFeatureName(feature, intl.messages, intl.locale, fabricatorData, filterGroups, useCollectionName);
  const finalName = parseInt(maxLength) === maxLength ? truncate(stringFeatureName, maxLength) : stringFeatureName
  return highlightStringOnSearch(finalName, groheFiltersSearchText);
};

FeatureName.propTypes = {
  maxLength: PropTypes.number,
  feature: PropTypes.object.isRequired,
  useCollectionName: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {filterGroups} = store.filterState;
  const {groheFiltersSearchText} = store.groheState;
  return {
    fabricatorData: store.fabricatorState,
    filterGroups,
    groheFiltersSearchText
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureName)
)

